module.exports = __webpack_public_path__ + "static/val-mezirici-107f3dee5001ff43d692f089923918de.png";